import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import AttachmentService from '../../../Services/AttachmentService';
import OpportunitySecurityChecklistService from '../../../Services/opportunitySecurityChecklistService';
import ContractImportItem from '../../../Domain/ContractImportItem';

// Step 1 of Import from Contract: pick the contract, keep it, read it. Single-page, so the wizard renders it as
// the compact centred modal. Its serviceFunction result reaches the panel via clickOnSave. No success popup: only
// the panel knows whether anything was read, and it says so itself.
export default class ImportContractUploadWindowDescription {
  static titleForCreate = 'Import Security Checklist from Contract';
  static titleForEdit = 'Import Security Checklist from Contract';
  static itemType = ContractImportItem;
  static finishButtonLabel = 'Upload and read';
  static suppressSuccessMessage = true;

  // Matches the server-side allow-list (AttachmentUploadParameters) and what the extraction can read.
  static acceptedTypes = '.pdf, .docx, .jpg, .jpeg, .png';

  static pagesInGeneralEditWizzard = [
    {
      label: 'Contract',
      fields: [
        {
          fieldName: 'file',
          label: 'Import RFP/Contract',
          className: 'col-12',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: ImportContractUploadWindowDescription.acceptedTypes,
          validityChecker: ValidityHelper.forRequiredFileField,
        },
      ],
    },
  ];

  // Stores the document, then reads it. Deliberately not rolled back if the extraction fails: the contract must
  // be retained, and a failed read is exactly when having the file matters.
  static serviceFunction = async (edited) => {
    const uploadResult = await ImportContractUploadWindowDescription.uploadContractAsync(edited);
    if (uploadResult?.error) {
      return uploadResult;
    }

    return OpportunitySecurityChecklistService.ExtractFromContract(edited.file, edited.ExistingNotes);
  };

  // An ordinary Opportunity attachment, so it lands on the Attachments tab. EntityTypeId 12 = Opportunity (no
  // frontend EntityType enum exists; the literal is used elsewhere too).
  static uploadContractAsync = (edited) => {
    const data = new FormData();
    data.append('file', edited.file);
    data.append('Name', edited.file?.name ?? 'Contract');
    data.append('Description', 'Contract uploaded for the Security Checklist import.');
    data.append('EntityTypeId', '12');
    data.append('EntityId', String(edited.OpportunityId));

    return AttachmentService.PostAttachmentFile(data);
  };
}
